import React from 'react';

import useStyles from './useStyles';

export const Box = ({ spacing, children, display, justifyContent, alignItems, gap }: Props) => {
  const classes = useStyles({ spacing, display, justifyContent, alignItems, gap });
  return <div className={classes.container}>{children}</div>;
};

export interface Props {
  spacing?: number;
  display?: 'flex' | 'block';
  justifyContent?: 'flex-end' | 'center';
  alignItems?: 'flex-start' | 'center' | 'flex-end';
  gap?: number;
  children: React.ReactNode;
}

export default Box;
